import React, { Suspense } from "react";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Redirect, Route, Switch } from "react-router-dom";
import { InvoicesPage } from "./invoices/InvoicesPage";
import { InvoiceSingle } from "./invoices/invoice-single/InvoiceSingle";
import { InvoiceCreateModal } from "./invoices/invoice-create-modal/InvoiceCreateModal";
import { InvoiceEdit } from "./invoices/invoice-edit/InvoiceEdit";

export default function AccountingPage() {
  return (
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {
            <Redirect
                exact={true}
                from={"/accounting"}
                to={"/accounting/invoices"}
            />
          }
          <Route path={"/accounting/invoices/new"}>
            {({ history, match }) => (
                <InvoiceCreateModal
                    show={match != null}
                    onHide={() => {
                      history.push("/accounting/invoices");
                    }}
                />
            )}
          </Route>
          <ContentRoute
              path={"/accounting/invoices/:id/edit"}
              component={InvoiceEdit}
          />
          <ContentRoute
              path={"/accounting/invoices/:id/view"}
              component={InvoiceSingle}
          />
          <ContentRoute path={"/accounting/invoices"} component={InvoicesPage} />
        </Switch>
      </Suspense>
  );
}
